import { useSelector } from "react-redux";
import useLanguageActions from "./_actions";

export const useLanguage = () => {
  const {
    getAllLanguage,
    getLanguageByFilter,
    getLanguageDetail,
    createLanguage,
    updateLanguage,
    setDefaultLanguage,
    changeSearchTerm,
    changeRowsPerPage,
    changeCurrentPage,
    refreshDialogState
  } = useLanguageActions();

  const data = useSelector((state) => state.language.data);
  const currentPage = useSelector((state) => state.language.currentPage);
  const totalRows = useSelector((state) => state.language.totalRows);
  const rowsPerPage = useSelector((state) => state.language.rowsPerPage);
  const searchTerm = useSelector((state) => state.language.searchTerm);
  const isError = useSelector((state) => state.language.isError);
  const isLoading = useSelector((state) => state.language.isLoading);
  const errorMessage = useSelector((state) => state.language.errorMessage);
  const isSubmitLoading = useSelector((state) => state.language.action.isLoading);

  return {
    // state
    data,
    currentPage,
    totalRows,
    rowsPerPage,
    searchTerm,
    isError,
    isLoading,
    isSubmitLoading,
    errorMessage,

    // actions
    getAllLanguage,
    getLanguageByFilter,
    getLanguageDetail,
    createLanguage,
    updateLanguage,
    setDefaultLanguage,
    changeSearchTerm,
    changeCurrentPage,
    changeRowsPerPage,
    refreshDialogState
  };
};

export { default as languageReducer } from "./_reducer";